export default __webpack_public_path__ + "static/media/cp_geo_rw.b876f6d9.svg";